import { ChainId } from '@ui/types/chain';
import { zeroAddress } from 'viem';

import { ExchangePool } from '../types';

const ADAPTER_TESTNET = '0x9F484EEb72dAAe011D0d28e9F0AdAC4d6F2e0b1B';
// Mainnet address not yet available, using testnet or placeholder
const ADAPTER_MAINNET = '0x4EE4b555c2160448Bcfb773854329194bCeD9139';

export const SLVMON_POOLS: Record<ChainId, ExchangePool[]> = {
  [ChainId.MONAD_MAINNET]: [
    {
      name: 'SLVMON Wrapper',
      adapter: ADAPTER_MAINNET,
      router: zeroAddress,
      type: 'slvmon',
      icon: '/images/tokens/slvmon.svg', // Assuming icon exists or will default
    },
  ],
  [ChainId.MONAD_TESTNET]: [
    {
      name: 'SLVMON Wrapper',
      adapter: ADAPTER_TESTNET,
      router: zeroAddress,
      type: 'slvmon',
      icon: '/images/tokens/slvmon.svg',
    },
  ],
};
